export const CLEAR_TROLLEY_ERRORS = 'waitrose/trolley-errors/CLEAR_TROLLEY_ERRORS';
export const ITEMS_SUCCESSFULLY_ADDED = 'waitrose/trolley-errors/ITEMS_SUCCESSFULLY_ADDED';
